import React from 'react';
import { Table } from '../../../../components/Sessions/Table';
import { billingsColumns } from '../../../../../dummy';

const BillingsTable = ({ billings = [] }) => {
    // Format the billing date to be more readable
    const formattedBillings = billings.map(billing => ({
        ...billing,
        formattedBillingDate: billing.billingDate && billing.billingDate !== '0001-01-01T00:00:00' 
            ? new Date(billing.billingDate).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
            : 'Not available'
    }));

    const columns = [
        {
            header: 'Billing ID',
            accessor: 'billingId',
            render: (billing) => (
                <span className="text-primary font-monospace small">
                    {billing.billingId}
                </span>
            )
        },
        {
            header: 'Date',
            accessor: 'billingDate',
            render: (billing) => billing.formattedBillingDate
        },
        {
            header: 'Tutor',
            accessor: 'tutorName'
        },
        {
            header: 'Language',
            accessor: 'sessionTitle'
        },
        {
            header: 'Amount',
            accessor: 'amount',
            render: (billing) => `$${billing.amount}`
        },
        {
            header: 'Payment Status',
            accessor: 'paymentStatus',
            render: (billing) => (
                <span className={`badge ${
                    billing.paymentStatus === 'Paid' ? 'bg-success' :
                    billing.paymentStatus === 'Pending' ? 'bg-warning' :
                    billing.paymentStatus === 'Failed' ? 'bg-danger' : 'bg-secondary'
                }`}>
                    {billing.paymentStatus}
                </span>
            )
        },
        {
            header: 'Payment Method',
            accessor: 'paymentMethod',
            render: (billing) => billing.paymentMethod || 'Not specified'
        }
    ];

    return (
        <div>
            <Table
                data={formattedBillings}
                columns={columns}
                pageSize={10}
                filterConfig={[]}
                buttonConfig={[]}
                searchableColumns={[]}
            />
        </div>
    );
};

export default BillingsTable;